import { render, staticRenderFns } from "./account-settings-navigation.vue?vue&type=template&id=5434ef52&scoped=true&"
import script from "./account-settings-navigation.vue?vue&type=script&lang=ts&"
export * from "./account-settings-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./account-settings-navigation.vue?vue&type=style&index=0&id=5434ef52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434ef52",
  null
  
)

export default component.exports